<div class="filter-dialog">
    <div class="apply-filter-header-container">
        <span class="apply-filter-header-text">FILTERING</span>
    </div>
    <div class="apply-filter-sub-header-container">
        <p  class="apply-filter-sub-head-text">Which filters would you like to apply</p>
    </div>

<div class="date-and-status-input-container">

        <div class="apply-filter-clients-dropdown-container">
            <div class="apply-filter-client-list-container">
                <mat-form-field class="apply-filter-select-client" appearance="outline">
                    <mat-label appRemoveAriaOwns>Select Client</mat-label>
                    <mat-select  multiple [(ngModel)]="selectedClientIds">
                        <mat-option style="background-color: white!important; padding: 6px!important;">
                                <div class="select-search-container-md">
                                    <div class="select-search-md">
                                        <ngx-mat-select-search placeholderLabel="Search Client" [formControl]="clientFilterCtrl">
                                            <span ngxMatSelectNoEntriesFound>
                                                No entries found
                                            </span>
                                        </ngx-mat-select-search>
                                    </div>
                                </div>
                            </mat-option>
                        <mat-option *ngFor="let customer of filterCustomerList" [value]="customer.id">
                            {{customer.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="filter-datepicker-container">
                <mat-form-field appearance="outline" class="" style="width: 145px;">
                    <mat-label>Start date</mat-label>
                    <input matInput [(ngModel)]="startDate" [matDatepicker]="pickerStart"  placeholder="Start" (dateInput)="setFilterStartDate($event)">           
                    <mat-datepicker-toggle matIconSuffix [for]="pickerStart" ></mat-datepicker-toggle>
                    <mat-datepicker #pickerStart></mat-datepicker>
                </mat-form-field>

                <mat-form-field appearance="outline" class="" style="width: 145px; margin-left:10px;">
                    <mat-label>End date</mat-label>
                    <input matInput  [(ngModel)]="endDate" [matDatepicker]="pickerEnd"   placeholder="End date" (dateInput)="setFilterEndDate($event)">
                    <mat-datepicker-toggle matIconSuffix [for]="pickerEnd"></mat-datepicker-toggle>
                    <mat-datepicker #pickerEnd></mat-datepicker>
                </mat-form-field>
            </div>

        <div class="filter-client-select-container">
            <div class="filter-client-input-container">
                <mat-form-field class="filter-client-select" appearance="outline">
                    <mat-label appRemoveAriaOwns>Select Status</mat-label>
                    <mat-select multiple  [(ngModel)]="selectedStatusIds">
                        <mat-option style="background-color: white!important; padding: 6px!important;">
                                <div class="select-search-container-md">
                                    <div class="select-search-md">
                                        <ngx-mat-select-search placeholderLabel="Search Status" [formControl]="statusFilterCtrl">
                                            <span ngxMatSelectNoEntriesFound>
                                                No entries found
                                            </span>
                                        </ngx-mat-select-search>
                                    </div>
                                </div>
                            </mat-option>
                        <mat-option *ngFor="let status of filterStatusList" [value]="status.id">
                            {{status.description}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div *ngIf="!data?.filterResult?.forApprovals" class="dropdown-container">
            <div class="filter-client-select-container">
                <div class="filter-client-input-container">
                    <mat-form-field class="filter-client-select" appearance="outline">
                        <mat-label appRemoveAriaOwns>Select Plant</mat-label>
                        <mat-select multiple [(ngModel)]="selectedPlantIds">
                            <mat-option style="background-color: white!important; padding: 6px!important;">
                                <div class="select-search-container-md">
                                    <div class="select-search-md">
                                        <ngx-mat-select-search placeholderLabel="Search Plant" [formControl]="plantFilterCtrl">
                                            <span ngxMatSelectNoEntriesFound>
                                                No entries found
                                            </span>
                                        </ngx-mat-select-search>
                                    </div>
                                </div>
                            </mat-option>
                            <mat-option *ngFor="let plant of filterPlantList" [value]="plant.id">
                                {{plant.plantCode}} - {{plant.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="filter-client-select-container">
                <div class="filter-client-input-container">
                    <mat-form-field class="filter-client-select" appearance="outline">
                        <mat-label appRemoveAriaOwns>Select Material</mat-label>
                        <mat-select multiple [(ngModel)]="selectedMaterialIds">
                            <mat-option style="background-color: white!important; padding: 6px!important;">
                                <div class="select-search-container-md">
                                    <div class="select-search-md">
                                        <ngx-mat-select-search placeholderLabel="Search Material" [formControl]="materialFilterCtrl">
                                            <span ngxMatSelectNoEntriesFound>
                                                No entries found
                                            </span>
                                        </ngx-mat-select-search>
                                    </div>
                                </div>
                            </mat-option>
                            <mat-option *ngFor="let material of filterMaterialList" [value]="material.id">
                                {{material.description}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>

    </div>
    <div class="filter-dialog-button-container">
        <button class="cancel-filtering-btn" mat-flat-button type="button" (click)="cancelFileringMyOrders()">
            <div class="cancel-filtering-content">
                <span><p class="cancel-filtering-text">Cancel</p></span>
            </div>
        </button>

        <button class="apply-filtering-btn" mat-flat-button type="button" (click)="applyFileringMyOrders()">
            <div class="apply-filtering-content">
                <span><p class="apply-filtering-text">Apply</p></span>
            </div>
        </button>
    </div>

</div>
